import { render, staticRenderFns } from "./IcArrowLeft.vue?vue&type=template&id=1ab62362&scoped=true"
import script from "./IcArrowLeft.vue?vue&type=script&lang=js"
export * from "./IcArrowLeft.vue?vue&type=script&lang=js"
import style0 from "./IcArrowLeft.vue?vue&type=style&index=0&id=1ab62362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab62362",
  null
  
)

export default component.exports